module.exports = __webpack_public_path__ + "static/media/ic_db_invest_solid.c10079eb.svg";